import { useEffect, useState } from "react";
import TabMenuAdmin from "../TabMenuAdmin/TabMenuAdmin";
import { getAllLotteryService } from "./services/adminLottery.service";
import { ApiLotteryData } from "./model/adminLottery.model";
import { lotteryTableDataAdapter } from "./adpaters/adminLottery.adapter";
import TableLottery from "./components/TableLottery";
import { Dialog } from "primereact/dialog";
import FormCreateLottery from "./components/FormCreateLottery";
import FormEditLottery from "./components/FormEditLottery";
import { useNavigate } from "react-router-dom";
import { ToastControlBackendModel } from "../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";
import ToastBackControl from "../../../../components/Sidebar/ToastBackControl/ToastBackControl";


const viewStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  .admin-lottery-root-container {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background-color: #f8fafc !important; /* Fuerza fondo gris ultra claro */
    min-height: 100vh;
    width: 100%;
    color: #1e293b;
  }
`;

function AdminLottery(): JSX.Element {
  const isAdminValue = localStorage.getItem("isAdmin");
  const navigate = useNavigate();
  const [lotteryData, setLotteryData] = useState<ApiLotteryData[]>([]);
  const [dataLotteryRow, setDataLotteryRow] = useState<ApiLotteryData>();
  const [dialogEditLottery, setDialogEditLottery] = useState(false);
  const [messageBackend, setMessageBackend] = useState<ToastControlBackendModel>({
    severityValue: "info",
    detailValue: "",
    lifeValue: 3000,
    validateShowMessage: false,
  });

  const getAllLottery = async () => {
    try {
      const response = await getAllLotteryService();
      if (response.length > 0) {
        setLotteryData(lotteryTableDataAdapter(response));
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (isAdminValue !== "1") {
      navigate("/");
    }
    getAllLottery();
  }, []);

  return (
    <div className="admin-lottery-root-container">
      <style>{viewStyles}</style>
      
      <TabMenuAdmin />
      
      {/* Contenedor principal adaptado y alineado */}
      <main className="admin-lottery-main-content px-3 md:px-5 py-4">
        
        {/* Cabecera Principal */}
        <div className="flex align-items-center justify-content-between pb-4 border-bottom-1 surface-border mb-4">
          <div className="flex align-items-center gap-3">
            <div className="admin-icon-box shadow-1">
              <i className="pi pi-ticket text-xl"></i>
            </div>
            <div className="flex flex-column justify-content-center">
              <h1 
                className="text-xl md:text-2xl font-bold m-0 tracking-tight" 
                style={{ color: "#1e293b" }} 
              >
                Administración de Sorteos
              </h1>
              <p className="text-sm text-500 m-0 mt-1 hidden sm:block">
                Panel de control para la creación, edición y gestión de sorteos activos e históricos.
              </p>
            </div>
          </div>
        </div>

        <>
          {messageBackend.validateShowMessage && (
            <ToastBackControl
              validateShowMessage={messageBackend.validateShowMessage}
              detailValue={messageBackend.detailValue}
              lifeValue={messageBackend.lifeValue}
              severityValue={messageBackend.severityValue}
            />
          )}

          <div className="flex flex-column gap-4 w-full">
            
            {/* Sección: Crear Sorteo (Tarjeta Blanca) */}
            <div className="admin-section-card">
              <h3 className="m-0 mb-4 font-bold flex align-items-center gap-2 text-base" style={{ color: "#475569" }}>
                <i className="pi pi-plus-circle text-lg" style={{ color: "#00A86B" }} />
                Crear nuevo sorteo
              </h3>
              <FormCreateLottery
                getAllLotteryData={getAllLottery}
                setMessageBackend={setMessageBackend}
              />
            </div>

            {/* Sección: Tabla de Registros (Tarjeta Blanca) */}
            {lotteryData.length > 0 && (
              <div className="admin-section-card">
                <h3 className="m-0 mb-3 font-bold flex align-items-center gap-2 text-base" style={{ color: "#475569" }}>
                  <i className="pi pi-list text-lg" style={{ color: "#00A86B" }} />
                  Listado de sorteos registrados
                </h3>
                <TableLottery
                  lotteryData={lotteryData}
                  setDataLotteryRow={setDataLotteryRow}
                  setDialogEditLottery={setDialogEditLottery}
                />
              </div>
            )}
          </div>

          {/* DIÁLOGO DE EDICIÓN TOTALMENTE BLANCO */}
          {dataLotteryRow && (
            <Dialog
              header={`Editar Sorteo #${dataLotteryRow.idLottery}`}
              visible={dialogEditLottery}
              onHide={() => setDialogEditLottery(false)}
              className="w-full max-w-30rem mx-3"
              breakpoints={{ '960px': '75vw', '641px': '100vw' }}
              draggable={false}
              resizable={false}
              pt={{
                root: { style: { backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)" } },
                header: { style: { backgroundColor: "#ffffff", color: "#1f2937", borderBottom: "1px solid #e5e7eb", padding: "1.5rem" } },
                content: { style: { backgroundColor: "#ffffff", padding: "1.5rem" } },
                closeButtonIcon: { style: { color: "#1f2937" } }
              }}
            >
              <FormEditLottery
                dataLottery={dataLotteryRow}
                getAllLotteryData={getAllLottery}
                setDialogEditLottery={setDialogEditLottery}
                setMessageBackend={setMessageBackend}
              />
            </Dialog>
          )}
        </>
        
      </main>
    </div>
  );
}

export default AdminLottery;